import { RichText } from '@wordpress/block-editor';
import { useContext, useEffect } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import { addFilter } from '@wordpress/hooks';
import * as TemplateControls from '../../blocks/wp-cv-builder/controls/index';
import BlockContext from '../../blocks/wp-cv-builder/context/blockContext';
import SectionItemContext from '../../blocks/wp-cv-builder/context/sectionItemContext';
import signatureImageUrl from '../../../includes/assets/img/sign-white.png';
import placeholderImageUrl from '../../../includes/assets/img/profile-image.png';
import icons from '../../options/icons';


const {
    Skills,
    Languages,
    Hobbies,
    Education,
    Experience,
    Reference,
    Awards,
    Tools,
    QrCode
} = TemplateControls;

function TemplateTwentyFour() {
    const {
         attributes, 
         setAttributes,
         updateSectionTitle, 
         footerVisibility, 
         scrollToSection, 
         scrollToInspectorControl, 
         togglePanel, 
         handleFooterClick,
         containerRef,
         showSocialIcon,
         socialIconVisibility,
         headerComponent,
         linkedinText,
         canvasRef,
         formatDate,
         currentData, 
         updateDataByStyleField
        } = useContext(BlockContext);
    const {
         style, 
         sectionItems24, 
         isFooterVisible, 
         footerLink, 
         signature, 
         footerBtnText, 
        footerBtnLink,
        showQRCode,
        phoneNumber,
        profileImage,
        firstName,
        lastName,
        designation,
        socialIcon,
        address,
        city,
        postalCode,
        email,
        about,
        aboutTitle,
        dateOfBirth,
        nationality,
        sectionCountTwentyFour
    } = attributes;
  function getTranslatedDefaults() {
    return [
        {
            id: '1',
            type: 'skills',
            title: __( 'Skills', 'cv-builder' ),
            items: [
                { name: __( 'JavaScript', 'cv-builder' ), percentage: 80 },
                { name: __( 'HTML', 'cv-builder' ), percentage: 90 },
                { name: __( 'CSS', 'cv-builder' ), percentage: 70 },
                { name: __( 'React', 'cv-builder' ), percentage: 85 },
                { name: __( 'WordPress', 'cv-builder' ), percentage: 75 },
                { name: __( 'PHP',  'cv-builder' ), percentage: 95 },
                { name: __('Python',  'cv-builder' ), percentage: 85 },
                { name: __('AI',  'cv-builder' ), percentage: 79 },
                { name: __('API',  'cv-builder' ), percentage: 74 },
            ],
        },
        {
            id: '2',
            type: 'languages',
            title: __( 'Languages', 'cv-builder' ),
            items: [
                { name: __( 'English', 'cv-builder' ), percentage: 90 },
                { name: __( 'Spanish', 'cv-builder' ), percentage: 75 },
                { name: __( 'Arabic', 'cv-builder' ), percentage: 75 },
            ],
        },
        {
            id: '3',
            type: 'hobbies',
            title: __( 'Hobbies', 'cv-builder' ),
            items: [
                { name: __( 'Music', 'cv-builder' ), icon: 'Music' },
                { name: __( 'Movie', 'cv-builder' ), icon: 'Movie' },
                { name: __( 'Writing', 'cv-builder' ), icon: 'Writing' },
                { name: __( 'Football', 'cv-builder' ), icon: 'Football' },
            ],
        },
        {
            id: '4',
            type: 'education',
            title: __( 'Education', 'cv-builder' ),
            items: [
                {
                    institution: __( 'University of California', 'cv-builder' ),
                    name: __( 'Computer Science', 'cv-builder' ),
                    degree: __( 'Bachelor', 'cv-builder' ),
                    city: __( 'California', 'cv-builder' ),
                    fromDate: 2020,
                    toDate: 2025,
                    current: false,
                    country:  __( 'USA', 'cv-builder' ),
                    educationDescription: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.'
                },
                {
                    institution: __( 'University of California', 'cv-builder' ),
                    name: __( 'Computer Science', 'cv-builder' ),
                    degree: __( 'Bachelor', 'cv-builder' ),
                    city: __( 'California', 'cv-builder' ),
                    fromDate: 2020,
                    toDate: 2025,
                    current: false,
                    country: __( 'USA', 'cv-builder' ),
                    educationDescription: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.'
                },
                {
                    institution: __( 'University of California', 'cv-builder' ),
                    name: __( 'Computer Science', 'cv-builder' ),
                    degree: __( 'Bachelor', 'cv-builder' ),
                    city: __( 'California', 'cv-builder' ),
                    fromDate: 2020,
                    toDate: 2025,
                    current: false,
                    country: __( 'USA', 'cv-builder' ),
                    educationDescription: __( 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.', 'cv-builder' )
                },
            ],
        },
        {
            id: '5',
            type: 'experience',
            title: __( 'Experience', 'cv-builder' ),
            items: [
                {
                    name: __( 'University of California', 'cv-builder' ),
                    designation: __( 'Web Developer', 'cv-builder' ),
                    present: false,
                    fromExpDate: '2020/10',
                    toExpDate: '2025/05',
                    experienceDescription: __( 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.', 'cv-builder' ),

                },
                {
                    name: __( 'University of California', 'cv-builder' ),
                    designation: __( 'Web Developer', 'cv-builder' ),
                    present: false,
                    fromExpDate: '2020/10',
                    toExpDate: '2025/05',
                    experienceDescription: __( 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.', 'cv-builder' ),
                },
                {
                    name: __( 'University of California', 'cv-builder' ),
                    designation: __( 'Web Developer', 'cv-builder' ),
                    present: false,
                    fromExpDate: '2020/10',
                    toExpDate: '2025/05',
                    experienceDescription: __( 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.', 'cv-builder' ),

                },
            ],
        },
        {
            id: '6',
            type: 'reference',
            title: __( 'Reference', 'cv-builder' ),
            items: [
                {
                    name: __( 'John Doe', 'cv-builder' ),
                    jobPosition: __( 'CEO', 'cv-builder' ),
                    company: __( 'Company Inc', 'cv-builder' ),
                    phone: '1234567890',
                    relation: __( 'Friend', 'cv-builder' ),

                },
                {
                    name: __( 'John Doe', 'cv-builder' ),
                    jobPosition: __( 'CEO', 'cv-builder' ),
                    company: __( 'Company Inc', 'cv-builder' ),
                    phone: '1234567890',
                    relation: __( 'Friend', 'cv-builder' ),

                },
            ],
        },
        {
            id: '7',
            type: 'awards',
            title: __( 'Achievements & Awards', 'cv-builder' ),
            items: [
                { name: __( 'Top Finance Leader LATAM – Global Capital Solutions, 2022', 'cv-builder' ) },
                { name: __( 'Outstanding Account Manager – Banco Nacional, 2018', 'cv-builder' ) },
                { name: __( 'Reduced finance operating expenses by $250K annually', 'cv-builder' ) },
                { name: __( 'Successfully led post-merger finance integration project across 3 countries', 'cv-builder' ) },
            ],
        },
        {
            id: '8',
            type: 'tools',
            title: __( 'Tools & Technologies', 'cv-builder' ),
            items: [
                { name: __( 'SAP, Oracle, QuickBooks, Xero', 'cv-builder' ) },
                { name: __( 'Microsoft Excel (Advanced), Power BI', 'cv-builder' ) },
                { name: __( 'Tableau, Zoho Finance Suite', 'cv-builder' ) },
                { name: __( 'CRM Tools: Salesforce, HubSpot', 'cv-builder' ) },
                { name: __( 'Banking platforms & compliance tools', 'cv-builder' ) },
            ],
        },
    ]
}
    
    useEffect(() => {
        if (!sectionItems24 || sectionItems24.length === 0) {
            setAttributes({
                sectionItems24: getTranslatedDefaults(),
            });
        }
    }, []);
        const firstFiveSections = sectionItems24 ? sectionItems24.slice(0, sectionCountTwentyFour) : [];
        const remainingSections = sectionItems24 ? sectionItems24.slice(sectionCountTwentyFour) : [];
   addFilter(
        'bwdcv-footer-visibility',
        'main-template/hide-footer',
        () => true
    );
  return (
    <div className={`${style} bwdcvs-main-wrapper bwdcvs-cv-builder-common`} ref={containerRef}>
        <div className="cv-builder-information">
          <div className="cv-header">
            {showQRCode && (
                <div className="cv-qrWrapper">
                    <QrCode tokenUrl={userData.tokenUrl} />
                </div>
            )}
            <div className="profile-img">
                {profileImage && profileImage.url ? (
                    <img src={profileImage.url} alt={profileImage.alt || 'Profile Image'} />
                ) : (
                    <img src={placeholderImageUrl} alt="Placeholder" />
                )}
            </div>
            <div className="profile-info">
                <div className="bwdcv-name-wrap">
                    <RichText
                        tagName="span"
                        className="first-name"
                        value={ currentData.firstName }
                        onChange={(value) => updateDataByStyleField('firstName', value)}
                />
                <RichText
                    tagName="span"
                    className="last-name"
                    value={ currentData.lastName }
                    onChange={(value) => updateDataByStyleField('lastName', value)}
                />
            </div>
                <RichText
                    className="designation"
                    value={ currentData.designation }
                    onChange={(value) => updateDataByStyleField('designation', value)}
                />
                {
                    (showSocialIcon && socialIconVisibility) &&(
                    <div className="social-icon" >
                        {
                            socialIcon && socialIcon.map((item, index) => {
                                return (
                                    <a key={index} href={item.link} target="_blank" rel="noopener noreferrer">
                                        <span className="icon">{icons[item.icon]}</span>
                                    </a>
                                );
                            })
                        }
                    </div>
                    )
                }
                <div className="bwdcv-contact-info">
                    <div className="bwdcv-phone-number">
                        <span className="bwdcv-phone-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513.64 513.64"><g><path d="m499.66 376.96-71.68-71.68c-25.6-25.6-69.12-15.359-79.36 17.92-7.68 23.041-33.28 35.841-56.32 30.72-51.2-12.8-120.32-79.36-133.12-133.12-7.68-23.041 7.68-48.641 30.72-56.32 33.28-10.24 43.52-53.76 17.92-79.36l-71.68-71.68c-20.48-17.92-51.2-17.92-69.12 0L18.38 62.08c-48.64 51.2 5.12 186.88 125.44 307.2s256 176.641 307.2 125.44l48.64-48.64c17.921-20.48 17.921-51.2 0-69.12z"></path></g></svg></span>
                        <RichText
                            tagName="span"
                            className="phone-number"
                             value={ phoneNumber }
                            onChange={(value) => setAttributes({phoneNumber: value})}
                        />
                    </div>
                    <div className="bwdcv-email">
                        <span className="bwdcv-email-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><g><path d="M298.789 313.693c-12.738 8.492-27.534 12.981-42.789 12.981-15.254 0-30.05-4.489-42.788-12.981L3.409 173.82A76.269 76.269 0 0 1 0 171.403V400.6c0 26.278 21.325 47.133 47.133 47.133h417.733c26.278 0 47.133-21.325 47.133-47.133V171.402a75.21 75.21 0 0 1-3.416 2.422z"></path><path d="m20.05 148.858 209.803 139.874c7.942 5.295 17.044 7.942 26.146 7.942 9.103 0 18.206-2.648 26.148-7.942L491.95 148.858c12.555-8.365 20.05-22.365 20.05-37.475 0-25.981-21.137-47.117-47.117-47.117H47.117C21.137 64.267 0 85.403 0 111.408a44.912 44.912 0 0 0 20.05 37.45z"></path></g></svg></span>
                        <RichText
                            tagName="span"
                            className="email"
                            value={ email }
                            onChange={(value) => setAttributes({email: value})}
                        />
                    </div>
                    <div className="bwdcv-address">
                        <span className="bwdcv-location-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g><path d="M12 0C7.038 0 3 4.066 3 9.065c0 7.103 8.154 14.437 8.501 14.745a.749.749 0 0 0 .998.001C12.846 23.502 21 16.168 21 9.065 21 4.066 16.962 0 12 0zm0 14c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5z"></path></g></svg></span>
                        <span className="address-container">
                            <RichText
                                tagName="span"
                                className="address"
                                value={ address }
                                onChange={(value) => setAttributes({address: value})}
                            />
                            {city && ', '}
                        </span>
                        {city && (
                            <RichText
                                tagName="span"
                                className="city"
                                value={ city }
                            onChange={(value) => setAttributes({city: value})}
                            />
                        )}
                        {postalCode && ', '}
                        {postalCode && (
                        <RichText
                            tagName="span"
                            className="postal-code"
                            value={ postalCode }
                            onChange={(value) => setAttributes({postalCode: value})}
                        />
                        )}
                    </div>
                </div>
                {headerComponent}
             </div>
            {showQRCode && (
                <div className="cv-qrWrapper">
                <canvas
                ref={canvasRef}
                style={{ display: "block", margin: "auto" }}
                ></canvas>
                {/* Custom Linkedin Text */}
                {linkedinText}
            </div>
            )}
        </div>
            <div className="cv-body">
                <div className="bwdcv-about">
                    <RichText
                        className="bwdcv-about-title"
                        value={ aboutTitle }
                        onChange={ ( value ) => setAttributes( { aboutTitle: value } ) }
                    />
                    <div className="bwdcv-about-content">
                        <RichText
                            className="about"
                            value={ about }
                            id="contentGeResult"
                            onChange={ ( value ) => setAttributes( { about: value } ) }
                        />
                        <div className="birth-date-wrap">
                            <strong>{__('Date of Birth', 'cv-builder')}: </strong> {formatDate(dateOfBirth)}
                        </div>
                        <div className="nationality-wrap">
                            <strong>{__('Nationality', 'cv-builder')}: </strong>
                            <RichText
                                tagName="span"
                                value={nationality}
                                onChange={(value) => setAttributes({nationality: value})}
                            />
                        </div>
                    </div>
                </div>
                <div className="bwdcv-main-wrapper">
                    <div className="cv-left-content">
                    {firstFiveSections.map((section, index) => (
                        <div key={section.id} className={`section section-${section.type}`} onClick={() => scrollToInspectorControl(section.id)}>
                                <div className="icon-title-wrap">
                                <RichText
                                    className="section-title"
                                    value={section.title}
                                    onChange={(value) => updateSectionTitle(index, value)}
                                    placeholder={`Enter ${section.type} section title...`}
                                    />
                                </div>
                                <div className={`bwdcvs-content-wrapper ${section.type}`}>
                                {Array.isArray(section.items) &&
                                    section.items.map((item, itemIndex) => (
                                    <SectionItemContext.Provider
                                        key={itemIndex}
                                        value={{ item, index, itemIndex }}
                                        >
                                        <div className="draggable-item">
                                            {section.type === 'skills' && <Skills />}
                                            {section.type === 'languages' && <Languages />}
                                            {section.type === 'hobbies' && <Hobbies />}
                                            {section.type === 'education' && <Education />}
                                            {section.type === 'experience' && <Experience />}
                                            {section.type === 'reference' && <Reference />}
                                            {section.type === 'awards' && <Awards />}
                                            {section.type === 'tools' && <Tools />}
                                        </div>
                                    </SectionItemContext.Provider>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="cv-right-content">
                    {remainingSections.map((section, index) => (
                            <div key={section.id} className={`section section-${section.type}`} onClick={() => scrollToInspectorControl(section.id)}>
                                <div className="icon-title-wrap">
                                    <RichText
                                        className="section-title"
                                        value={section.title}
                                        onChange={(value) => updateSectionTitle(index, value)}
                                        placeholder={`Enter ${section.type} section title...`}
                                    />
                                </div>
                                <div className={`bwdcvs-content-wrapper ${section.type}`}>
                                {Array.isArray(section.items) &&
                                    section.items.map((item, itemIndex) => (
                                    <SectionItemContext.Provider
                                        key={itemIndex}
                                        value={{ item, index, itemIndex }}
                                    >
                                        <div className="draggable-item">
                                            {section.type === 'skills' && <Skills />}
                                            {section.type === 'languages' && <Languages />}
                                            {section.type === 'hobbies' && <Hobbies />}
                                            {section.type === 'education' && <Education />}
                                            {section.type === 'experience' && <Experience />}
                                            {section.type === 'reference' && <Reference />}
                                            {section.type === 'awards' && <Awards />}
                                            {section.type === 'tools' && <Tools />}
                                        </div>
                                    </SectionItemContext.Provider>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            {
                (isFooterVisible && footerVisibility) && (
                <div className="footer" onClick={handleFooterClick}>
                    <div className="footer-content">
                        <a href={footerLink} target="_blank" className="youtube-link"><svg viewBox="0 0 1024 1024"><path d="M852.727563 392.447107C956.997809 458.473635 956.941389 565.559517 852.727563 631.55032L281.888889 993.019655C177.618644 1059.046186 93.090909 1016.054114 93.090909 897.137364L93.090909 126.860063C93.090909 7.879206 177.675064-35.013033 281.888889 30.977769L852.727563 392.447107 852.727563 392.447107Z"/></svg></a>
                        <img src={signature?.url || signatureImageUrl} alt={signature?.alt || 'Placeholder'} className="signature" />
                        <a href={footerBtnLink} target="_blank" className='footer-btn'>{footerBtnText}</a>
                    </div>
                </div>								
                )
            }
        </div>
    </div>
  )
}

export default TemplateTwentyFour
